import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  requestData: null,
  lastSavedAt: null,
};

const requestDataSlice = createSlice({
  name: 'requestData',
  initialState,
  reducers: {
    setData: (state, action) => {
      state.requestData = action.payload;
    },
    clearData: (state) => {
      state.requestData = null;
      state.lastSavedAt = null;
    },
    setLastSavedAt: (state, action) => {
      state.lastSavedAt = action.payload;
    },
  },
});

export const { setData, clearData, setLastSavedAt } = requestDataSlice.actions;
export default requestDataSlice.reducer;

